import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-network-connectivity',
  templateUrl: './network-connectivity.component.html',
  styleUrls: ['./network-connectivity.component.scss'],
})
export class NetworkConnectivityComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {}

}
